import { cn } from "../lib/utils";
import { Reveal } from "./Reveal";

export function SectionHeading({ eyebrow, title, titleAccent, subtitle, align = "center", className, dark = false }) {
  return (
    <div className={cn("max-w-3xl", align === "center" && "mx-auto text-center", className)}>
      {eyebrow && (
        <Reveal>
          <p className={cn("eyebrow mb-4", dark && "text-emerald-300")}>{eyebrow}</p>
        </Reveal>
      )}
      <Reveal delay={0.1}>
        <h2 className={cn("font-sans text-display-md font-semibold text-balance leading-tight tracking-tight", dark ? "text-white" : "text-navy-800")}>
          {title}
          {titleAccent && (
            <span className={cn("font-display italic font-normal", dark ? "text-emerald-300" : "text-emerald-500")}> {titleAccent}</span>
          )}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.2}>
          <p className={cn("body-lg mt-6 text-balance", dark && "!text-white/65")}>{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
}